<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <form name="sbmnForm" novalidate>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-2">
              <label class="form-label" for="submissionId">
                Submission Id
              </label>
            </div>
            <div class="col-sm-2">
              @if (mode === 'edit') {
<textarea
                        id="efile-sub-id"
                        class="efile-form-control"
                        name="efileSubmissionId"
                        [(ngModel)]="selectedSubId"
                        [disabled]="mode === 'edit'"
                        cols="20"
                        rows="1"></textarea>
}
              
              <!-- Dropdown for submission selection in create mode -->
              @if (mode !== 'edit') {
<select
                      id="efile-sub-id"
                      class="efile-form-control"
                      name="efileSubmissionId"
                      [(ngModel)]="selectedSubId">
                <option [ngValue]="null">Search or enter a new value...</option>
                @for (item of submissions; track $index) {
<option [ngValue]="item">
                  {{item.SUBMISSION_ID}}
                </option>
}
              </select>
}
              
              @if (showSubmissionIdRequiredError && !selectedSubId && mode !== 'edit') {
<span class="form-error-container">
                Submission Id is required.
              </span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="keyId">
                Key Id
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-key-id"
                        class="efile-form-control"
                        name="efileKeyId"
                        [(ngModel)]="keyId"
                        (ngModelChange)="showKeyIdRequiredError = false"
                        [disabled]="mode === 'edit'"
                        cols="20"
                        rows="1"></textarea>
              @if (showKeyIdRequiredError) {
<span class="form-error-container">Key Id is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="entity">
                Entity
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-entity"
                        class="efile-form-control"
                        name="efileEntity"
                        [(ngModel)]="entity"
                        (ngModelChange)="showEntityRequiredError = false"
                        cols="20"
                        rows="1"></textarea>
              @if (showEntityRequiredError) {
<span class="form-error-container">Entity is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="entitySub">
                Entity Sub
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-entity-sub"
                        class="efile-form-control"
                        name="efileEntitySub"
                        [(ngModel)]="entitySub"
                        (ngModelChange)="showEntitySubRequiredError = false"
                        cols="20"
                        rows="1"></textarea>
              @if (showEntitySubRequiredError) {
<span class="form-error-container">Entity Sub is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="parentId">
                Parent Id
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-parent-id"
                        class="efile-form-control"
                        name="efileParentId"
                        [(ngModel)]="parentId"
                        cols="20"
                        rows="1"></textarea>
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="oracleUserId">
                Oracle User Id
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-oracle-user-id"
                        class="efile-form-control"
                        name="efileOracleUserId"
                        [(ngModel)]="oracleUserId"
                        (ngModelChange)="showOracleUserIdRequiredError = false"
                        cols="20"
                        rows="1"></textarea>
              @if (showOracleUserIdRequiredError) {
<span class="form-error-container">Oracle User Id is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="entityTypeId">
                Entity Type Id
              </label>
            </div>
            <div class="col-sm-2">
              <textarea id="efile-entity-type-id"
                        class="efile-form-control"
                        name="efileEntityTypeId"
                        [(ngModel)]="entityTypeId"
                        (ngModelChange)="showEntityTypeIdRequiredError = false"
                        cols="20"
                        rows="1"></textarea>
              @if (showEntityTypeIdRequiredError) {
<span class="form-error-container">Entity Type Id is required.</span>
}
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Footer for modal with standardized buttons -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="saving"
          (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="delete-button"
          type="button"
          [disabled]="mode === 'create' || !keyId || deleting"
          (click)="delete()">
    @if (deleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
